(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aries-autumn-leaves"] && !Shopify.designMode) return;
  try {
    (() => {
    const template = document.getElementById('aries-autumn-leaf-template');
    if (!template) return;
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let cleanupTimer;
    let layer;
    const clearLeaves = () => {
      window.clearTimeout(cleanupTimer);
      if (layer) layer.remove();
      layer = null;
    };
    const startLeaves = () => {
      clearLeaves();
      if (motion.matches) return;
      layer = document.createElement('div');
      layer.className = 'aries-autumn-layer';
      layer.setAttribute('aria-hidden', 'true');
      layer.setAttribute('inert', '');
      const count = window.matchMedia('(max-width: 749px)').matches ? 12 : 22;
      const colors = ['#c64f29', '#e6812e', '#dba333', '#a4372b', '#b56c28'];
      for (let i = 0; i < count; i++) {
        const leaf = document.createElement('span');
        leaf.className = 'aries-autumn-leaf';
        const start = Math.random() * 100 - 50;
        const sway = Math.random() * 100 - 50;
        const rotation = (Math.random() > 0.5 ? 1 : -1) * (110 + Math.random() * 160);
        leaf.style.setProperty('--leaf-x', ((i + Math.random()) / count * 100).toFixed(2) + '%');
        leaf.style.setProperty('--leaf-size', (25 + Math.random() * 19).toFixed(1) + 'px');
        leaf.style.setProperty('--leaf-color', colors[i % colors.length]);
        leaf.style.setProperty('--leaf-duration', (3.7 + Math.random() * 0.6).toFixed(2) + 's');
        leaf.style.setProperty('--leaf-delay', (Math.random() * 0.6).toFixed(2) + 's');
        leaf.style.setProperty('--leaf-start', start.toFixed(1) + 'deg');
        leaf.style.setProperty('--leaf-middle', (start + rotation * 0.45).toFixed(1) + 'deg');
        leaf.style.setProperty('--leaf-end', (start + rotation).toFixed(1) + 'deg');
        leaf.style.setProperty('--leaf-sway', sway.toFixed(1) + 'px');
        leaf.style.setProperty('--leaf-drift', (sway * -0.6).toFixed(1) + 'px');
        leaf.append(template.content.firstElementChild.cloneNode(true));
        layer.append(leaf);
      }
      document.body.append(layer);
      cleanupTimer = window.setTimeout(clearLeaves, 5000);
    };
    motion.addEventListener('change', clearLeaves);
    window.addEventListener('pagehide', clearLeaves);
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) startLeaves();
    });
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', startLeaves, { once: true });
    } else {
      startLeaves();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
